import { ContentWrapper } from './contact_us.styles';

export default function ContactUs() {
  return (
    <ContentWrapper>
      <p>
        Brainshake & More sp. z o.o. sp. k.
        <br />
        Ulica Franciszka Kawy 18/10
        <br />
        01-496 Warszawa
      </p>

      <p>NIP 5252464701</p>

      <h3>Dane kontaktowe</h3>

      <p>
        <strong>Dział obsługi klienta:</strong>
        <br />
        Adres email: <a href="mailto:kontakt@bubblejoy.pl">kontakt@bubblejoy.pl</a>
      </p>
    </ContentWrapper>
  );
}
